import React from 'react';

import {CompetitionsSliderWidgetProps} from "../models/competitions-slider-widget.props";
import {ACTION_TYPES, WIDGET_TYPES} from "../../../core/consts";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";

export class CompetitionsSliderWidgetAllScoresLinkProps extends CompetitionsSliderWidgetProps {}

export const CompetitionsSliderWidgetAllScoresLink = (({controller}: CompetitionsSliderWidgetAllScoresLinkProps) => {
  const {state, device} = controller;
  const linkProps = {
    className: 'competitions-slider-widget-see-all-scores-label',
    style: {
      color:  useThemeColor(COLORS.accentPrimary),
      textDecoration: 'underline'
    },
    onClick: () => onAllScoresLinkClickEvent()
  }

  const onAllScoresLinkClickEvent = () => controller.action(ACTION_TYPES.allScoresLinkClick, {
    widgetType: WIDGET_TYPES.slider,
    partner: state.appSettings.publisherSettings?.id,
    screenResolution: device.screenWidth,
    url: state.allScoresUrl
  });

  return (
    <div {...linkProps}>{state.terms.WIDGET_SEE_ALL_SCORES_TEXT}</div>
  )
});
